import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { RoutingService } from '../../../core/services/routing.service';
import { QualityControlSubWorkOrder } from '../../../common/quality-control/model/sub-work-order-qc.ts';
import {
  SchedulerStageRegisterProgressComponent,
  SchedulerStageRegisterProgressTypes,
} from '../dialog/finish-stage/finish-stage.component';
import { SchedulerStageItemApiService } from '../api/table.service';
import { MatDialog } from '@angular/material/dialog';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';
import { BomDetailsComponent } from '../../../shared/dialog/bom-details/bom-details.component';
import { TrimmingInspectionPayload } from '../interfaces/trimming-inspection.interface';

@Injectable()
export class SchedulerStageItemService {
  protected readonly routerService = inject(RoutingService);
  protected readonly apiStageRouter = inject(SchedulerStageItemApiService);
  protected readonly dialog = inject(MatDialog);
  protected readonly departmentService = inject(SingleDepartmentService);

  registerProgress(
    item: QualityControlSubWorkOrder
  ): Observable<QualityControlSubWorkOrder> {
    if (!item) {
      return;
    }
    let toQc: boolean;
    return this.apiStageRouter.getItemMeasure(item.assemblyTitle).pipe(
      switchMap((data) => {
        toQc = !!data;
        return this.registerProgressDialog(item);
      }),
      switchMap((res) => {
        return this.registerProgressReport(item, res, toQc);
      })
    );
  }

  protected registerProgressDialog(
    itemSelected: QualityControlSubWorkOrder
  ): Observable<SchedulerStageRegisterProgressTypes['return']> {
    return this.dialog
      .open(SchedulerStageRegisterProgressComponent, {
        data: {
          maxQuantity: itemSelected.quantity,
          title: itemSelected.title,
          department: this.departmentService.NAME,
          operatorType: 'Auxiliar',
        },
        minWidth: '50%',
      })
      .afterClosed()
      .pipe(filter((data) => !!data));
  }

  protected registerProgressReport(
    itemSelected: QualityControlSubWorkOrder,
    res: SchedulerStageRegisterProgressTypes['return'],
    toQc?: boolean
  ): Observable<QualityControlSubWorkOrder> {
    let nextStageName: string | undefined = undefined;
    const currentStageName = itemSelected.stage?.title;

    if (currentStageName === 'Trimming' && toQc) {
      nextStageName = 'Quality Control';
    } else if (currentStageName === 'Hoses Inspection') {
      nextStageName = 'Trimming';
    } else {
      nextStageName = undefined;
    }

    return this.apiStageRouter.finishSubWorkOrderStage({
      itemId: itemSelected.workOrderId,
      stageId: itemSelected.stageId,
      quantity: res.quantity,
      scrapReasons: res.scrapReasons,
      shiftId: res.shiftId,
      operators: res.operatorId
        ? [
            {
              operatorId: res.operatorId,
            },
          ]
        : undefined,
      machineId: res.machineId,
      toValidation: !toQc,
      nextStage: nextStageName
    });
  }

  showBom(item: QualityControlSubWorkOrder): void {
    this.dialog.open(BomDetailsComponent, {
      data: {
        searching: item.workOrderId,
      },
    });
  }

  saveTrimmingInspection(payload: TrimmingInspectionPayload) {
    return this.apiStageRouter.saveTrimmingInspection(payload);
  }
}
